module.exports = __webpack_public_path__ + "assets/img/type_3.ad5189bf.png";